<template>
  <div class="app-wrapper">
    <app-header class="header" />
    <div class="main-container">
      <app-main />
    </div>
    <app-footer v-if="showFooter" />
  </div>
</template>

<script>
import AppHeader from './header'
import AppMain from './main'
import AppFooter from './footer'

export default {
  name: 'LayoutH5',
  components: {
    AppHeader,
    AppMain,
    AppFooter
  },
  data() {
    return {}
  },
  computed: {
    showFooter() {
      const { layoutOptions } = this.$store.getters
      if (layoutOptions && layoutOptions.footer !== undefined) {
        return layoutOptions.footer
      }
      return true
    }
  },
  methods: {},
  mounted() { }
}
</script>

<style lang="scss" scoped>
.app-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
  }
  .main-container {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/h5/index.vue